import ArticleTags from './ArticleTags';

export default ArticleTags;
